import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";

type Props = {
  value: string;
  onChange: (value: string) => void;
}

const Search: React.FC<Props> = ({value, onChange}) => {
  return (
    <Input
      variant='filled'
      size='small'
      placeholder='Search'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      prefix={
        <SearchOutlined style={{ color: 'rgba(0, 0, 0, 0.4)', fontSize: 16, marginRight: 8 }} />
      }
    />
  );
};

export default Search;